// =============================================================================
// Identity & contact details used across the site (business card, footer,
// structured data…). Edit here to change them everywhere.
// =============================================================================

export const SITE = {
  name: "Bryan Cellier",
  /** Canonical production URL */
  url: "https://bryancellier.fr",
  email: "bryan.cellier.pro@gmail.com",
  /** Shown on the business card of the home page */
  phone: "06 34 03 25 39",
  phoneHref: "+33634032539",
  linkedinHandle: "bryancellier",
  designerHandle: "Kyo",
  locality: "France",
} as const;

/**
 * Transparent portrait of the home hero. Replace the file (same name) to
 * update it: a cut-out PNG/WebP, bottom-aligned, ~1200px wide.
 */
export const PORTRAIT = {
  src: "/images/bryan-cellier.webp",
  width: 995,
  height: 1279,
} as const;

// =============================================================================

/**
 * Absolute URL of the deployment: production domain, Vercel preview URL or
 * localhost.
 */
export function getSiteUrl(): string {
  if (process.env.VERCEL_ENV === "preview" && process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }
  return (process.env.NEXT_PUBLIC_SITE_URL ?? "http://localhost:3000").replace(
    /\/$/,
    ""
  );
}

// =============================================================================
